export default "__VITE_ASSET__VQYCaBpE__"